import { render, staticRenderFns } from "./TraxAccountAuthLogin.vue?vue&type=template&id=197c449a"
import script from "./TraxAccountAuthLogin.vue?vue&type=script&lang=js"
export * from "./TraxAccountAuthLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports